module.exports = __webpack_public_path__ + "img/excel.c7bac599.svg";